import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { ServiceFactory } from '../../../../../../services/ServiceFactory';
import { ChangeAscriptionRequestPayload, CreateChangeAscriptionResponse } from '../../../../../../services/invoice/InvoiceService';

interface Props {
  invoiceNumber: string;
}

export default function useCreateChangeAscriptionMutation({
  invoiceNumber,
}: Props): UseMutationResult<CreateChangeAscriptionResponse, unknown, ChangeAscriptionRequestPayload> {
  return useMutation({
    mutationKey: ['createChangeAscription', invoiceNumber],
    mutationFn: async (data: ChangeAscriptionRequestPayload): Promise<CreateChangeAscriptionResponse> => {
      const response = await ServiceFactory.createInvoiceService().createChangeAscriptionInvoice(data);

      return response;
    },
  });
}
